import React, { useState } from 'react';
import { Modal, Form, message } from 'antd';
import LocationForm from './LocationForm';
import apiClient from '../services/api';

interface LocationModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: (location: any) => void;
  companies?: any[];
  locations?: any[];
  isSuperAdmin?: boolean;
  currentUser?: any;
}

const LocationModal: React.FC<LocationModalProps> = ({ 
  visible, 
  onCancel, 
  onSuccess, 
  companies = [], 
  locations = [], 
  isSuperAdmin = false,
  currentUser 
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values: any) => {
    setLoading(true);
    try {
      const location = await apiClient.createLocation(values);
      message.success('Tạo vị trí thành công!');
      onSuccess(location);
      form.resetFields();
    } catch (error) {
      message.error('Tạo vị trí thất bại!');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Tạo vị trí mới"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      <LocationForm
        form={form}
        onFinish={handleFinish}
        loading={loading}
        submitText="Tạo mới"
        companies={companies}
        locations={locations}
        isSuperAdmin={isSuperAdmin}
        currentUser={currentUser}
        hideFields={isSuperAdmin ? [] : ['company_id']}
      />
    </Modal>
  );
};

export default LocationModal; 